import { render, staticRenderFns } from "./CompareLayout.vue?vue&type=template&id=065f2a81"
import script from "./CompareLayout.vue?vue&type=script&lang=js"
export * from "./CompareLayout.vue?vue&type=script&lang=js"
import style0 from "./CompareLayout.vue?vue&type=style&index=0&id=065f2a81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports